/**
 * Utilities for handling reasoning models
 */

/**
 * Determines if a model is a reasoning model
 * @param {string} modelName - The name of the model to check
 * @returns {boolean} - True if the model is a reasoning model
 */
export function isReasoningModel(modelName) {
  if (!modelName) return false;

  // Check for DeepSeek reasoning models
  if (
    modelName.includes("deepseek-reasoner") ||
    modelName.includes("deepseek-r1") ||
    modelName.includes("deepseek-v2") ||
    modelName.includes("deepseek-v3")
  ) {
    return true;
  }

  // Check for xAI/Grok reasoning models
  if (
    modelName.includes("grok-4-0709") ||
    modelName === "grok-4" ||
    modelName.includes("grok-code-fast-1")
  ) {
    return true;
  }

  // Check for specific OpenAI reasoning models
  return (
    modelName.includes("o1") ||
    modelName.includes("o3") ||
    modelName.includes("r1")
  );
}

/**
 * Gets reasoning effort from context data or assistant settings
 * @param {Object} contextData - Context data which may contain reasoning_effort
 * @param {Object} assistant - Assistant settings which may contain reasoning_effort
 * @returns {string|null} - The reasoning effort or null if not found
 */
export function getReasoningEffort(contextData = {}, assistant = {}) {
  // Check context data first
  if (contextData?.reasoning_effort) {
    return contextData.reasoning_effort;
  }

  // Then check assistant metadata
  if (assistant?.metadata?.reasoning_effort) {
    return assistant.metadata.reasoning_effort;
  }

  // Then check assistant settings
  if (assistant?.settings?.reasoning_effort) {
    return assistant.settings.reasoning_effort;
  }

  // Default value if specified
  if (contextData?.default_reasoning_effort) {
    return contextData.default_reasoning_effort;
  }

  // If reasoning is explicitly enabled, use "high"
  if (
    contextData?.enable_reasoning === true ||
    assistant?.settings?.enable_reasoning === true
  ) {
    return "high";
  }

  return null;
}
